const document = `<svg title="document icon" aria-hidden="true" id="icon-document" data-name="icon-document" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><defs><style>.cls-1 { fill-rule: evenodd; }</style></defs><path class="cls-1" d="m83.12,23.3v.63h-17.26s0-16.99,0-16.99l17.26,16.36ZM60.19,6v23.6h22.93s0,60.4,0,60.4H13V6h47.19Zm7.55,34.09H29.04v8h38.7v-8Zm-38.7,18.1h38.7v8H29.05v-8Z"/></svg>`;
export {
  document
};
//# sourceMappingURL=files.js.map
